import { ReactNode } from 'react'
import { Tabs } from '../../atoms/tabs'

type TabPanelProps = {
  id: string
  children: ReactNode
}

export const TabPanel = ({ id, children }: TabPanelProps) => (
  <Tabs.Content value={id}>{children}</Tabs.Content>
)
